import React from 'react';
import { renderBlocks } from '../DynamicPage/utils';
const DynamicPost = (props) => {
    const { post: { title, content, featured_image }, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "nero-wrapper-960" }, featured_image && (React.createElement("img", { className: "blog__featured-image", src: featured_image.image, alt: title }))),
        renderBlocks(content)));
};
export { DynamicPost };
